<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <b-overlay :show="loading">
            <iq-card>
                <template v-slot:headerTitle>
                    <h4 class="text-white text-center">{{ $t('externalUser.apply_for_job_circulation_details') }} </h4>
                </template>
                <template v-slot:headerAction>
                    <router-link to="apply-for-job" :class="'btn btn-primary text-light'">{{ $t('externalUser.apply_for_job') }} {{ $t('globalTrans.list') }}</router-link>
                </template>
            <template v-slot:body>
                <b-row>
                    <b-col>
                        <list-report-head :base-url="awarenessEventServiceBaseUrl" :uri="reportHeadingList" :org-id="3">
                            <h3 class="text-center mt-4" style="text-decoration:underline;">{{ $t('job_fair_management.job_fair') }}</h3>
                        </list-report-head>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" sm="12">
                        <!-- <b-overlay :show="loading"> -->
                            <b-overlay>
                                <b-row class="mt-3">
                                    <b-col lg="12" sm="12" class="top-height pl-4  pr-3" style="padding-left: 10px; padding-right: 10px">
                                        <template>
                                            <div style="color:black;" class="mb-4">
                                            {{ $t('job_fair_management.para_1') }} {{ $i18n.locale === 'bn' ? formData.location_bn : formData.location_en }} {{ $t('job_fair_management.para_1') }}
                                            </div>
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="10" offset="1">
                                        <table style="border: 1px solid black;border-collapse: collapse;">
                                            <b-tr>
                                                <td style="width: 20%;color:black;" class="text-left pl-4 " >{{ $t('job_fair_management.circular_title') }}</td>
                                                <td class="text-center" style="width: 5%;color:black;">:</td>
                                                <td style="width: 75%;color:black;" class="text-left">{{ $i18n.locale === 'bn' ? formData.title_bn : formData.title_en }}</td>
                                            </b-tr>
                                            <b-tr>
                                                <td style="width: 20%;color:black;"  class="text-left pl-4 " >{{ $t('job_fair_management.location') }}</td>
                                                <th class="text-center" style="width: 5%;color:black;">:</th>
                                                <td style="width: 75%;color:black;" class="text-left">{{ $i18n.locale === 'bn' ? formData.location_bn : formData.location_en }}</td>
                                            </b-tr>
                                            <b-tr>
                                                <td style="width: 20%;color:black;"  class="text-left pl-4 " >{{ $t('job_fair_management.application_deadline') }}</td>
                                                <th class="text-center" style="width: 5%;color:black;">:</th>
                                                <td style="width: 75%;color:black;" class="text-left">{{ formData.application_deadline|dateFormat }}</td>
                                            </b-tr>
                                        </table>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col lg="12" sm="12" class="top-height pl-4  pr-3" style="padding-left: 10px; padding-right: 10px">
                                        <template>
                                            <div style="color:black;" class="mb-5">
                                            {{ $t('job_fair_management.para_1') }} {{ $i18n.locale === 'bn' ? formData.location_bn : formData.location_en }} {{ $t('job_fair_management.para_1') }}
                                            </div>
                                        </template>
                                    </b-col>
                                </b-row>
                            <b-overlay>
                                <b-row>
                                    <b-col lg="10" offset="1">
                                        <b-table-simple bordered>
                                            <b-tr>
                                                <th class="text-center" style="width:20%">{{ $t('globalTrans.division') }}</th>
                                                <th class="text-center" style="width:17%">{{ $t('globalTrans.from_date') }}</th>
                                                <th class="text-center" style="width:17%">{{ $t('globalTrans.to_date') }}</th>
                                                <th class="text-center" style="width:17%">{{ $t('job_fair_management.start_time') }}</th>
                                                <th class="text-center" style="width:17%">{{ $t('job_fair_management.end_time') }}</th>
                                            </b-tr>
                                                <tr v-for="(indexData,index) in formData.details" :key="index">
                                                    <td>
                                                        {{ getDisabilityTypeNameList(indexData.division_ids) }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ indexData.from_date | dateFormat }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ indexData.to_date | dateFormat }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ EngBangNum(tConvert(indexData.start_time)) }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ EngBangNum(tConvert(indexData.end_time)) }}
                                                    </td>
                                                </tr>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-overlay>
                            <b-row class="mt-3">
                                    <b-col lg="12" sm="12" class="top-height pl-4  pr-3" style="padding-left: 10px; padding-right: 10px">
                                        <template>
                                            <div style="color:black;" class="mb-5">
                                            {{ $t('job_fair_management.para_1') }}
                                            </div>
                                        </template>
                                    </b-col>
                                </b-row>
                            </b-overlay>
                        <!-- </b-overlay> -->
                    </b-col>
                </b-row>
                <div class="row">
                <div class="col-sm-3"></div>
                <div class="col text-right">
                    <b-button type="button" @click="register" variant="primary" class="mr-2">{{ $t('externalUser.apply') }}</b-button>
                    &nbsp;
                    <router-link to="apply-for-job" :class="'btn btn-danger text-light'">{{ $t('globalTrans.cancel') }}</router-link>
                </div>
                </div>
            </template>
            </iq-card>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { jobApplyCircularShow, reportHeadingList, jobApplyStoreApi } from '../../api/routes'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
export default {
  props: ['id'],
  components: {
      ListReportHead
  },
  data () {
    return {
      loading: false,
      formData: [],
      detailsData: [],
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
      reportHeadingList: reportHeadingList
    }
  },
  created () {
        this.getEligibityCategory()
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    divisionList: function () {
        return this.$store.state.ExternalUser.commonObj.divisionList.filter(item => item.status === 0)
    }
  },
  watch: {
  },
  methods: {
    async getEligibityCategory () {
        this.loading = true
        const resultData = await RestApi.getData(awarenessEventServiceBaseUrl, jobApplyCircularShow + '/' + this.$route.query.id)
        const tmpData = resultData.data
        this.formData = tmpData
        this.loading = false
    },
    EngBangNum (n) {
        if (this.$i18n.locale === 'bn') {
            return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
        } else {
            return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
        }
    },
    tConvert (time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
      if (time.length > 1) {
        time = time.slice(1)
        time[5] = +time[0] < 12 ? ' ' + this.$t('ds_exam_management.am') : ' ' + this.$t('ds_exam_management.pm')
        time[0] = +time[0] % 12 || 12
      }
      return time.join('')
    },
    getDisabilityTypeNameList (divisionIds) {
        const arr = []
        if (divisionIds.constructor === Array) {
            divisionIds.forEach(item => {
            const divisionId = this.divisionList.find(obj => obj.value === item)
            const divisionName = this.currentLocale === 'en' ? ' ' + divisionId.text_en : ' ' + divisionId.text_bn
            arr.push(divisionName)
            })
        }
        return arr.toString()
    },
    async register () {
        this.loading = true
        let result = null
        const param = {
            circular_id: parseInt(this.$route.query.id),
            patient_id: ''
        }
        result = await RestApi.postData(awarenessEventServiceBaseUrl, jobApplyStoreApi, param)
        if (result.success) {
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.$t('externalUser.job_msg'),
            color: '#D6E09B'
            })
            this.$router.push('/patient-panel/apply-for-job')
            if (result.notification && this.$store.state.emitNotification) {
              this.$socket.emit('send-notification', result.notification)
            }
        } else {
            this.$refs.form.setErrors(result.errors)
        }
        this.loading = false
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
